const LANGUAGES = [
    { code: 'en', label: 'EN' },
    { code: 'ua', label: 'UA' },
    { code: 'es', label: 'ES' },
    { code: 'ru', label: 'RU' }
];

export { LANGUAGES }; 